export const content = {
        backersSection : {
            title: 'Backers',
            subtitle: 'Hash Protocol is backed by the world\'s top crypto funds and ecosystem builders.'
        },
    }

export const FooterBoxes = [
    {
        title: 'Join our growing community',
        text: 'Be part of our growing community of developers and innovators who are helping build the Hash Protocol network.',
        button: {
            text: 'Help build Hash Protocol',
            href: '/join-our-community/',
            id: 'operator',
            type: 'simple'
        }
    },
    {
        title: 'Build on our developer beta',
        text: 'Build on Hash Protocol and be the first to explore the benefits of its novel architecture.',
        button: {
            text: 'Join the waitlist',
            href: '#',
            id: 'developer',
            type: 'modal'
        }
    }
]

